import Vue from 'vue'
//import router from '../router';

export default {
    state: {
        cities: [],
    },
    getters: {
        cities: state => state.cities,
    },
    actions: {
        GET_CITIES: ({commit, dispatch}, val) => {
            val.loading(true);
            Vue.http.get('api/City/' + val.search).then((res) => {
                //this.cities = res.data;
                commit('SET_CITIES', res.data);
                val.loading(false);
            }).catch(() => {
                val.loading(false);
            });
        }
    },
    mutations: {
        SET_CITIES: (state, cities) => {
            state.cities = cities;
        },
    }
};